import { Card } from "@clipboard-health/ui-components";
import { Box, CardActions, Skeleton, Stack } from "@mui/material";

import { CARD_ACTIONS_BUTTON_HEIGHT_PX } from "../../Chat/constants";
import { ShiftCardDivider } from "../Shift/Card/CardDivider";
import { BookingCardContentWrapper } from "../Shift/CardContentWrapper";
import { ShiftCardPillsWrapper } from "../Shift/PillsWrapper";

export function ShiftTimeProposalMessageCardSkeleton() {
  return (
    <Stack alignItems="center" width="100%">
      <Box sx={{ paddingY: 5 }}>
        <Skeleton variant="text" width={160} />
      </Box>
      <Card outlined aria-label="Shift time proposal card skeleton" sx={{ width: "100%" }}>
        <BookingCardContentWrapper sx={{ gap: 0 }}>
          <Stack gap={5}>
            <ShiftCardPillsWrapper>
              <Skeleton variant="rounded" width={72} height={24} />
              <Skeleton variant="rounded" width={112} height={24} />
            </ShiftCardPillsWrapper>

            {/* Proposed time */}
            <Stack gap={2}>
              <Skeleton variant="text" width={160} />
              <Box>
                <Skeleton variant="text" width="60%" />
              </Box>
            </Stack>

            {/* Original time */}
            <Stack gap={2} sx={{ opacity: 0.5 }}>
              <Skeleton variant="text" width={120} />
              <Box>
                <Skeleton variant="text" width="55%" />
              </Box>
            </Stack>
          </Stack>

          <ShiftCardDivider />
          <CardActions>
            <Stack direction="row" justifyContent="space-between" width="100%" gap={2}>
              <Skeleton variant="rounded" width="100%" height={CARD_ACTIONS_BUTTON_HEIGHT_PX} />
              <Skeleton variant="rounded" width="100%" height={CARD_ACTIONS_BUTTON_HEIGHT_PX} />
            </Stack>
          </CardActions>
        </BookingCardContentWrapper>
      </Card>
    </Stack>
  );
}
